// Données exactes du Book Commercial Sunpac Energy

export const companyInfo = {
  name: "Sunpac Energy",
  slogan: "Votre transition énergétique simplifiée",
  tagline: "Des écosystèmes énergétiques complets pour votre indépendance énergétique",
  owner: "Stéphane Rioult",
  address: "Rue du Bourg 27, 1003 Lausanne",
  phone: "021 588 00 64",
  mobile: "079 391 78 99",
  email: "contact@sunpac-energy.ch",
  website: "www.sunpac-energy.ch",
  colors: {
    primary: "#e57200",
    secondary: "#03224c",
    white: "#ffffff"
  }
};

// Textes exacts du book - Page 5
export const aboutText = {
  intro: "Fondée à Lausanne avec l'ambition de transformer chaque toiture en source d'indépendance énergétique fiable et pérenne, Sunpac Energy accompagne les particuliers et les professionnels de Suisse romande dans leur passage aux énergies vertes.",
  vision: "Notre vision : nous croyons en une énergie locale maîtrisée et optimisée. Nous pensons qu'une installation solaire ne doit pas seulement produire de l'électricité, mais maximiser la performance globale du bâtiment. C'est pourquoi nous installons des systèmes énergétiques complets et évolutifs pensés pour durer : solaire photovoltaïque, stockage d'énergie, chauffage durable, isolation et fenêtres.",
  quote: "Dans un monde où la transition énergétique n'est plus une option mais une nécessité, notre entreprise est née d'une conviction forte : rendre l'énergie solaire performante, durable et réellement rentable pour nos clients."
};

// Page 5 - Valeurs
export const values = [
  {
    title: "Proximité",
    description: "En tant qu'installateur local nous sommes au plus proche des besoins de nos clients pour une transition énergétique de qualité.",
    icon: "MapPin"
  },
  {
    title: "Engagement",
    description: "Nous contribuons chaque jour à la transition énergétique du pays et nous engageons pour un monde plus vert.",
    icon: "Heart"
  },
  {
    title: "Confiance",
    description: "Nous nouons avec nos clients des relations de confiance, en toute transparence et sans mauvaise surprise tout au long du projet.",
    icon: "Shield"
  }
];

// Page 6
export const whatWeDo = "En tant qu'installateur de solutions énergétiques durables auprès des foyers et des entreprises vaudoises, notre objectif est de proposer des systèmes solaires et de chauffage à la fois performants, accessibles et optimisés, afin de favoriser l'autonomie énergétique au meilleur coût. Nous prenons en charge des projets de rénovation énergétique globale, allant de l'installation de panneaux photovoltaïques à l'amélioration de l'isolation du bâtiment, en passant par le remplacement des fenêtres. Nos solutions sont pensées pour maximiser l'autoconsommation et réduire la dépendance au réseau.";

// Page 11 - Forces
export const strengths = [
  {
    title: "Zéro sous-traitance",
    description: "Projet 100% en interne pour un contrôle qualité optimal"
  },
  {
    title: "Solutions personnalisées",
    description: "Chaque installation est unique et adaptée à vos besoins"
  },
  {
    title: "Un interlocuteur unique",
    description: "Un seul responsable de A à Z pour simplifier votre projet"
  },
  {
    title: "Les meilleures garanties",
    description: "Jusqu'à 30 ans de garantie avec nos partenaires premium"
  },
  {
    title: "Projet clé en main",
    description: "De l'étude à l'installation, nous gérons tout"
  },
  {
    title: "Bureau d'études interne",
    description: "Dimensionnement et conception par nos ingénieurs"
  }
];

export const strengthsQuote = "Chaque installation est pensée pour maximiser l'autoconsommation et réduire la dépendance au réseau. Nous garantissons une qualité constante et un suivi de projet fiable et direct.";

// Page 11 - Description forces
export const strengthsIntro = "Sunpac Energy n'installe pas seulement des panneaux solaires et des pompes à chaleur. L'entreprise conçoit des écosystèmes énergétiques complets grâce à des solutions énergétiques innovantes et performantes : production photovoltaïque optimisée, stockage intelligent, optimisation de la production d'eau chaude. Notre force réside dans un accompagnement personnalisé et de A à Z pour chaque projet, toujours avec transparence et pédagogie pour nos clients.";

// Page 12 - Processus
export const projectSteps = [
  {
    step: 1,
    title: "Analyse & objectifs",
    description: "Consommation actuelle, projets, contraintes, financement"
  },
  {
    step: 2,
    title: "Visite & étude techniques",
    description: "Relevés, ombrages, structure, acoustique, hydraulique, dimensionnement"
  },
  {
    step: 3,
    title: "Démarches administratives",
    description: "Demandes d'autorisations, subventions et annonces"
  },
  {
    step: 4,
    title: "Préparation & Installation",
    description: "Chantier planifié, sécurisé et contrôle qualité à chaque étape"
  },
  {
    step: 5,
    title: "Mise en service",
    description: "Paramétrage, test, vérification et explications d'utilisation au client"
  },
  {
    step: 6,
    title: "Suivi & SAV",
    description: "SAV, conseils d'autoconsommation et monitoring"
  }
];

export const projectStepsMessage = "Chaque projet passe par notre bureau d'étude, dimensionné et installé par notre propre équipe, pour un accompagnement de A à Z !";

// Page 10 - Pourquoi la transition
export const whyTransition = {
  intro: "La transition énergétique représente aujourd'hui un levier stratégique pour réduire durablement vos coûts, valoriser votre bien immobilier et améliorer votre confort au quotidien. Entre les nouvelles mesures en vigueur depuis le 1er janvier 2026, l'évolution des prix de l'énergie et les aides financières proposées selon les cantons, le contexte est particulièrement propice pour passer à l'action.",
  conclusion: "La transition énergétique n'est plus une option : c'est une opportunité concrète de réduire ses coûts, valoriser son patrimoine et préparer durablement l'avenir."
};

export const benefits = [
  {
    title: "Indépendance énergétique",
    description: "Grâce à l'énergie solaire, vous produisez et consommez votre propre énergie, tout en réduisant fortement votre dépendance au réseau et à votre fournisseur d'électricité.",
    icon: "Zap"
  },
  {
    title: "Économies sur les factures",
    description: "Produire sa propre énergie solaire et opter pour une pompe à chaleur en remplacement d'un système fossile permet de réduire ses dépenses énergétiques tout en gardant un meilleur contrôle sur son budget.",
    icon: "TrendingDown"
  },
  {
    title: "Se protéger contre la hausse des prix",
    description: "La transition énergétique constitue également une forme de sécurité et permet de réduire sa dépendance aux fluctuations des marchés de l'énergie (électricité, gaz, mazout) et de stabiliser son coût du kWh.",
    icon: "Shield"
  },
  {
    title: "Plus-value du bien immobilier",
    description: "Un bien rénové et énergétiquement performant gagne en valeur : meilleure efficacité énergétique, charges maîtrisées, image plus moderne et attractivité renforcée lors de la revente.",
    icon: "TrendingUp"
  },
  {
    title: "Confort de l'habitat",
    description: "Une pompe à chaleur permet par exemple de bénéficier d'une température plus homogène, d'une régulation plus précise et d'un confort thermique optimal tout au long de l'année.",
    icon: "Home"
  },
  {
    title: "Aides financières & cadre incitatif",
    description: "Agir dès maintenant permet de bénéficier des subventions et des programmes d'aide fédéraux et communaux, réduisant ainsi l'investissement initial tout en améliorant la rentabilité du projet.",
    icon: "BadgeSwissFranc"
  }
];

// Pages 14-20 - Solutions (textes exacts du book)
export const solutions = [
  {
    id: "solar",
    title: "Panneaux solaires",
    shortDesc: "Production d'électricité renouvelable pour votre autoconsommation",
    description: "Les panneaux solaires photovoltaïques convertissent le rayonnement solaire en électricité grâce à des cellules, généralement en silicium. L'énergie produite est d'abord consommée directement dans le bâtiment (autoconsommation), tandis que l'excédent peut être réinjecté dans le réseau. Le dispositif repose sur des micro-onduleurs et peut être complété par un système de pilotage des usages afin d'optimiser la part d'électricité consommée sur place.",
    image: "/images/solutions/panneaux-solaires.jpg",
    brands: ["SUNPOWER"],
    warranty: "30 ans de garantie pièces et main d'œuvre",
    benefits: [
      "Réduction des factures",
      "Accès à l'indépendance énergétique",
      "Plus-value du bien immobilier",
      "Rentabilité avec l'autoconsommation",
      "Compatible avec une pompe à chaleur",
      "Production locale et renouvelable"
    ],
    icon: "Sun"
  },
  {
    id: "micro-inverters",
    title: "Micro-onduleurs",
    shortDesc: "Optimisation de la production de votre installation solaire",
    description: "Les micro-onduleurs sont des dispositifs électroniques installés directement sous chaque panneau solaire. Contrairement à un onduleur central, ils convertissent individuellement le courant continu produit par chaque module en courant alternatif, ce qui permet d'optimiser la production globale de l'installation, notamment en cas d'ombrage partiel. Cette technologie offre également un suivi précis des performances panneau par panneau et améliore la fiabilité du système.",
    image: "/images/solutions/boiler-thermodynamique.jpg",
    brands: ["ENPHASE IQ8M"],
    benefits: [
      "Production solaire optimisée",
      "Meilleure gestion de l'ombrage",
      "Suivi précis des performances",
      "Plus grande fiabilité vs. onduleur central",
      "Sécurité renforcée réduisant les risques",
      "Évolutivité du système sans contrainte"
    ],
    icon: "Cpu"
  },
  {
    id: "batteries",
    title: "Batteries de stockage",
    shortDesc: "Stockez votre énergie pour une autonomie maximale",
    description: "Une batterie de stockage permet de conserver l'électricité produite par vos panneaux solaires, généralement en journée, afin de la réutiliser ultérieurement, notamment en soirée. Elle est gérée par un système intelligent qui optimise les phases de charge et de décharge en fonction de votre production, de votre consommation et, dans certains cas, des signaux du réseau. Elle améliore ainsi votre taux d'autoconsommation.",
    image: "/images/solutions/batteries-stockage.jpg",
    brands: ["ENPHASE", "ATMOCE"],
    benefits: [
      "Hausse de l'autoconsommation",
      "Rentabilité de l'installation solaire",
      "Lissage des pics de consommation",
      "Meilleure autonomie énergétique",
      "Sécurité de l'approvisionnement",
      "Baisse des factures du foyer"
    ],
    icon: "Battery"
  },
  {
    id: "heat-pumps",
    title: "Pompes à chaleur",
    shortDesc: "Chauffage performant et économique pour votre habitat",
    description: "Une pompe à chaleur air-eau (PAC) capte les calories présentes dans l'air extérieur pour les élever à une température utile, afin de chauffer le logement et produire l'eau chaude sanitaire. Très performante, elle peut restituer plusieurs kWh de chaleur pour seulement 1 kWh d'électricité consommé. Ce type de PAC, particulièrement répandu en Suisse romande, est compatible avec des radiateurs ou un plancher chauffant.",
    image: "/images/solutions/pompe-chaleur.jpg",
    brands: ["Vaillant", "Panasonic"],
    benefits: [
      "Réduction des coûts de chauffage",
      "Confort thermique stable et précis",
      "Réduction des émissions de CO2",
      "Plus économique vs. chaudière au mazout",
      "Complément avec les panneaux solaires",
      "Valorisation du bien immobilier"
    ],
    icon: "Wind"
  },
  {
    id: "thermodynamic-boilers",
    title: "Boilers thermodynamiques",
    shortDesc: "Eau chaude sanitaire économique et écologique",
    description: "Un boiler thermodynamique est un chauffe-eau intégrant une pompe à chaleur qui capte les calories présentes dans l'air (local technique, cave ou air extrait) pour chauffer l'eau sanitaire. Bien plus économe qu'un chauffe-eau électrique classique, il réduit significativement la consommation d'électricité. Il peut également être piloté pour fonctionner en priorité lorsque votre production solaire est la plus élevée.",
    image: "/images/solutions/boiler-thermodynamique.jpg",
    brands: ["Vaillant", "Panasonic"],
    benefits: [
      "Réduction des coûts d'eau chaude",
      "Rendement plus élevé vs. boiler classique",
      "Complément avec les panneaux solaires",
      "Solution simple et compacte",
      "Baisse des émissions de CO2",
      "Confort d'eau chaude constant"
    ],
    icon: "Droplet"
  },
  {
    id: "insulation",
    title: "Isolation",
    shortDesc: "Réduisez vos besoins en chauffage durablement",
    description: "L'isolation thermique d'un bâtiment (toiture, combles, façades, planchers) a pour objectif de réduire les échanges de chaleur entre l'intérieur et l'extérieur. En limitant les déperditions, elle permet de conserver la chaleur en hiver et la fraîcheur en été. Elle est conçue en fonction de la structure du bâtiment, des ponts thermiques et des objectifs visés, qu'il s'agisse de confort, d'économies d'énergie ou de performance globale.",
    image: "/images/solutions/isolation.jpg",
    benefits: [
      "Réduction des besoins en chauffage",
      "Confort et température plus stable",
      "Protection contre les surchauffes",
      "Dimensionnement pour une future PAC",
      "Baisse des risques de moisissures",
      "Plus-value du bien immobilier"
    ],
    icon: "Home"
  },
  {
    id: "windows",
    title: "Fenêtres",
    shortDesc: "Menuiseries performantes pour moins de pertes",
    description: "Le remplacement des fenêtres consiste à installer des menuiseries performantes, équipées de double ou triple vitrage selon les besoins, avec des cadres isolants et une pose soignée afin de limiter les infiltrations d'air. Ces nouvelles fenêtres réduisent les pertes de chaleur, améliorent l'étanchéité du bâtiment et permettent ainsi de diminuer les besoins en chauffage tout en renforçant le confort au quotidien.",
    image: "/images/solutions/fenetres.jpg",
    benefits: [
      "Réduction des pertes de chaleur",
      "Baisse des factures de chauffage",
      "Meilleur confort thermique intérieur",
      "Réduction de la condensation",
      "Meilleure isolation acoustique",
      "Performance énergétique"
    ],
    icon: "Square"
  }
];

// Page 7 - Marques partenaires
export const partnersIntro = "Nous collaborons avec des marques reconnues et des fabricants de référence dans le secteur de l'énergie afin de garantir à nos clients des équipements fiables, durables et performants. Chacune de nos marques est sélectionnée avec exigence pour répondre aux plus hauts standards de qualité et d'efficacité suisses. Grâce à ces technologies éprouvées, nous proposons des solutions innovantes, adaptées aux besoins spécifiques de chaque projet.";

export const partners = [
  { name: "SUNPOWER", category: "Solaire" },
  { name: "ENPHASE", category: "Solaire" },
  { name: "ATMOCE", category: "Batteries" },
  { name: "Vaillant", category: "Pompe à chaleur" },
  { name: "Panasonic", category: "Pompe à chaleur" }
];

// Page 9 - Subventions
export const subsidies = [
  {
    title: "Rétribution unique (RU)",
    description: "Pour le photovoltaïque, la principale mesure de soutien est la rétribution unique (RU), administrée par Pronovo. Cette subvention peut couvrir jusqu'à environ 30 % des coûts d'investissement d'une installation solaire, avec un montant calculé en fonction de la puissance mise en place.",
    organization: "Pronovo"
  },
  {
    title: "Le Programme Bâtiments",
    description: "Concernant le chauffage, le Programme Bâtiments, financé conjointement par la Confédération et les cantons, accompagne le remplacement des systèmes fossiles par des pompes à chaleur ou d'autres solutions renouvelables.",
    organization: "Confédération & Cantons"
  },
  {
    title: "Aides communales et cantonales",
    description: "À ces mécanismes s'ajoutent également diverses aides communales et cantonales, ainsi que des déductions fiscales liées aux travaux d'assainissement énergétique.",
    organization: "Canton de Vaud"
  }
];

export const legalFramework = {
  title: "La Stratégie énergétique 2050",
  description: "En Suisse, la transition énergétique s'appuie sur la Stratégie énergétique 2050 mise en place par la Confédération, dont l'objectif est de garantir un approvisionnement fiable, durable et respectueux de l'environnement. Cette orientation vise notamment à diminuer la dépendance aux énergies fossiles tout en renforçant la performance énergétique des bâtiments. Dans ce cadre, les réglementations fédérales, notamment la Loi sur l'électricité, ainsi que les politiques cantonales soutiennent activement le développement des installations photovoltaïques et encouragent le remplacement des systèmes de chauffage fossiles par des solutions plus durables, telles que les pompes à chaleur.",
  intro: "Pour soutenir cette évolution, la Confédération et les cantons ont déployé différents dispositifs d'aide financière destinés aux propriétaires souhaitant engager des travaux de rénovation énergétique. À ces mécanismes s'ajoutent également diverses aides communales et cantonales, ainsi que des déductions fiscales liées aux travaux d'assainissement énergétique."
};
